import { IH2HMatch } from "core-integration/src/store/leagues/types";
import Alert from "plos/src/components/alerts/Alert";
import { vars } from "plos/src/styles";
import { useTranslation } from "react-i18next";
import CupBase from "../../../../img/icons/cup.svg?react";
import { winnerWrapper } from "./winnerStatus.css";

interface WinnerStatusProps {
  match: IH2HMatch;
  isCup: boolean;
}

const WinnerStatus = ({ match, isCup }: WinnerStatusProps) => {
  const { t } = useTranslation("leaguesAndCups");
  if (!match.winner) {
    return null;
  }

  const winnerName =
    match.winner === match.entry_1_entry
      ? match.entry_1_name
      : match.entry_2_name;

  return (
    <>
      {match.tiebreak && (
        <Alert isInline isCentered>
          {match.tiebreak === "goals_scored" &&
            t(
              "winnerStatus.tieBreak.goalsScored",
              "Tie-break - {{winnerName}} progressed on most goals scored",
              { winnerName },
            )}
          {match.tiebreak === "goals_conceded" &&
            t(
              "winnerStatus.tieBreak.goalsConceded",
              "Tie-break - {{winnerName}} progressed on fewest goals conceded",
              { winnerName },
            )}
          {match.tiebreak === "default" &&
            t(
              "winnerStatus.tieBreak.default",
              "Tie-break - {{winnerName}} progressed by virtual coin toss",
              { winnerName },
            )}
        </Alert>
      )}
      {isCup && match.event === 38 && (
        <span className={winnerWrapper}>
          <CupBase color={vars.colors.copnr[50].backgroundColor} />
          <span>{winnerName}</span>
        </span>
      )}
    </>
  );
};

export default WinnerStatus;
